var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HasSubscriptions } from '../components/has-subscriptions';
import { SaveSearchService } from './save-search.service';
var PostAuthenticationService = /** @class */ (function (_super) {
    __extends(PostAuthenticationService, _super);
    function PostAuthenticationService(_saveSearchService) {
        var _this = _super.call(this) || this;
        _this._saveSearchService = _saveSearchService;
        _this.KEY_SAVE_SEARCH = 'post-authentication_save-listing';
        return _this;
    }
    PostAuthenticationService.prototype.storeSaveSearch = function (name, notification, listing) {
        var saveSearch = {
            name: name,
            notification: notification,
            listing: listing
        };
        try {
            window.localStorage.setItem(this.KEY_SAVE_SEARCH, JSON.stringify(saveSearch));
        }
        catch (error) {
            console.error(error);
        }
    };
    PostAuthenticationService.prototype.processSaveSearch = function () {
        try {
            if (this.isSaveSearchReady()) {
                var saveListingSearch = JSON.parse(window.localStorage.getItem(this.KEY_SAVE_SEARCH));
                this._saveSearchService.saveSearch(saveListingSearch.name, saveListingSearch.notification, saveListingSearch.listing);
                this.removeSaveSearch();
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    PostAuthenticationService.prototype.isSaveSearchReady = function () {
        try {
            return window.localStorage.hasOwnProperty(this.KEY_SAVE_SEARCH);
        }
        catch (error) {
            console.error(error);
        }
    };
    PostAuthenticationService.prototype.removeSaveSearch = function () {
        try {
            window.localStorage.removeItem(this.KEY_SAVE_SEARCH);
        }
        catch (error) {
            console.error(error);
        }
    };
    return PostAuthenticationService;
}(HasSubscriptions));
export { PostAuthenticationService };
